import React from "react";
import Seo from "../../components/seo";
import { Link } from "gatsby";
import useIsInViewport from "../../hooks/useIsInViewport";

/* START: images import */
import marticka from "../../img/approach/marticka.jpg";
import standards from "../../img/approach/standards.jpg";
import code from "../../img/approach/code.jpg";
/* END: images import */

const Intro = ({ setObserverRef }) => (
    <div ref={setObserverRef} data-observer={0}>
        <article className="article" id="how">
            <h2 className="line sm animate-1">Základ, na kterém stavíme</h2>
            <div>
            <blockquote className="desktop noq animate-2">
                <p>🏅 Naše prověřené základy  <br />💰 Vám snižují náklady! </p>
            </blockquote>
        </div>
            <p className="animate-2">
                Prověřené stavební bloky vám sniží náklady, takže se můžeme soustředit na funkce na míru, které vaše firma skutečně potřebuje.
            </p>
            <p className="animate-3">
                Přinášíme soustředěnou expertizu v několika klíčových oblastech a hotové business platformy, které nabízejí výjimečnou svobodu přizpůsobení za bezkonkurenční
                cenu. Stavíme na prověřených komponentách, snižujeme náklady a více hodnoty směřujeme do funkcí, které dělají váš byznys jedinečným.
            </p>
            {/* <h3 className="animate-4">Naše rodinné stříbro</h3>
            <p className="animate-5">
                <strong>Shop8</strong> je naše e-commerce platforma, která podporuje více zemí, portfolií, měn i integrací třetích stran. Je vysoce přizpůsobitelná a roste s vaším
                katalogem i provozem.
            </p>
            <p className="animate-6">
                <strong>Admin8</strong> je modulární CMS s výkonným page builderem. Rozložení je složené z vyměnitelných UI bloků. GraphQL a REST API mohou pohánět weby, blogy nebo
                mobilní aplikace.
            </p>
            <p className="animate-7">
                <strong>Model8</strong> je náš UI systém pro stavbu komplexních administračních platforem, ověřený na robustních řešeních včetně skladového hospodářství,
                realitních systémů a právních či vymáhacích platforem.
            </p> */}
        </article>
        <article className="article animate-3" id="extending">
            <h2 className="line animate-4">Naše rodinné stříbro</h2>
            <h3 className="animate-8">Admin8</h3>
            
            
            <p className="animate-9"><strong>Admin8</strong> je modulární CMS s výkonným page builderem. Rozložení na stránce je složené z vyměnitelných UI bloků. Pomocí GraphQL a REST API pak můžeme pohánět weby, blogy nebo mobilní aplikace.</p>
        </article>
        <article id="working" className="clearfix animate-6">
            <article className="article animate-7">
            <h3 className="animate-8">Shop8</h3>
            <p className="animate-5">
            Shop8 je naše e-commerce platforma, která podporuje více zemí, portfolií, měn i integrací třetích stran. Je vysoce přizpůsobitelná a roste s vaším
            katalogem i provozem.
            </p>
                
            </article>
            <article className="article animate-7">
                <h3 className="animate-8">Model8</h3>
                <p className="animate-9"><strong>Model8</strong> je náš UI systém pro stavbu komplexních administračních platforem, ověřený na robustních řešeních včetně skladového hospodářství,
                realitních systémů a právních či vymáhacích platforem.</p>
            </article>
        </article>
    </div>
);

const Planning = ({ indx, setObserverRef }) => (
    <article className="article" id="planning" ref={setObserverRef} data-observer={indx}>
        <h2 className="line sm animate-1">Martička - náš virtuální pedant</h2>
        <img className="animate-5" src={marticka} alt="Marticka.cz" />
        <p className="animate-2">
            Rádi myslíme dopředu. Chceme mít věci správně od začátku a často pomáháme klientům rozplést problémy z projektů postavených jinde. Proto s vámi od první chvíle
            pečlivě vymezíme rozsah. Nabízíme široké spektrum služeb, ale klidně dodáme jen část, kterou potřebujete, ať už čistý HTML front-end nebo kompletní CMS.
        </p>
        <h3 className="animate-3">Rozpočet</h3>
        <p className="animate-4">
            Můžeme pracovat s předem definovaným rozpočtem nebo u dlouhodobých klientů sledujeme čas v našem vlastním nástroji{" "}
            <a href="https://www.marticka.cz/" target="_blank" rel="noopener noreferrer">
                Martičky
            </a>
            . Na konci každého měsíce dodáme přehled hodin strávených na jednotlivých projektech.
        </p>
    </article>
);

const Code = ({ indx, setObserverRef }) => (
    <article className="article" id="code" ref={setObserverRef} data-observer={indx}>
        <h2 className="line sm animate-1">Kvalita je součástí, ne dodatek</h2>
        <img className="animate-2" src={code} alt="Code" />
        <p className="animate-3">
            K vývoji přistupujeme s důrazem na srozumitelnost, udržovatelnost a reálnou hodnotu pro uživatele. Systémy stavíme jako modulární komponenty, které rostou bez zbytečné
            složitosti. Kombinujeme zkušené inženýrství s AI-asistovanými workflow, abychom postupovali rychleji a přitom udrželi kontrolu nad kvalitou a designem. Výsledkem jsou
            řešení, která jsou předvídatelná, snadno pochopitelná a jednoduchá na rozšíření.
        </p>
        <p className="animate-4">
            Testování je součástí toho, jak stavíme, ne něco přidaného na konec. Používáme automatizované testy a praktickou validaci, aby funkce fungovaly v reálných scénářích.
            Tím snižujeme regresy, zvyšujeme spolehlivost a děláme změny bezpečnějšími. Pro klienty to znamená stabilnější releasy a nižší dlouhodobé náklady, nám to pak dává
            jistotu při každém nasazení.
        </p>
    </article>
);

const Standards = ({ indx, setObserverRef }) => (
    <article className="article" id="standards" ref={setObserverRef} data-observer={indx}>
        <h2 className="line sm animate-1">Zkušenost určuje směr, AI zrychluje cestu</h2>
        <img className="animate-3" src={standards} alt="standards" />
        <p className="animate-2">
            Propojujeme hlubokou praktickou zkušenost s nejnovějšími AI modely, abychom přinesli spolehlivé inženýrství a rychlý vhled. Náš přístup nenahrazuje odbornost,
            posiluje ji. AI urychluje analýzu, zkoumá možnosti a odhaluje vzory, zatímco zkušení inženýři vedou rozhodování a ověřují výsledky. Tato rovnováha nám umožňuje
            postupovat rychleji na začátku, dříve odhalit příležitosti a omezit pokusy a omyly bez ztráty kvality či kontroly.
            <br /><br />
            V praxi to znamená rychlejší objevování, lépe informovaná rozhodnutí a řešení přizpůsobená skutečným potřebám, ne domněnkám. Ukotvením AI v reálné zkušenosti z
            doručování zajistíme, že to, co stavíme, je nejen inovativní, ale i praktické, udržovatelné a připravené do produkce. Pro klienty to znamená rychlejší progres,
            jasnější směr a výsledky, které obstojí i po prvním dodání.
        </p>
    </article>
);

const Experience = ({ indx, setObserverRef }) => (
    <article className="article" id="experience" ref={setObserverRef} data-observer={indx}>
        <div className="text animate-1">
            <p>
                Přečtěte si pár zajímavostí o nás a <Link to="/cz/o-nas/">našem týmu</Link>
            </p>
        </div>
    </article>
);

const halfContentSections = [Standards, Code, Planning, Experience];

const Approach = () => {
    const { setRef } = useIsInViewport();
    return (
        <>
            <Seo title="Jak pracujeme" lang="cs" />
            <div>
                <Intro setObserverRef={setRef} />
                <section className="halfContentSection">
                    {halfContentSections.map((Component, index) => (
                        <Component key={index} indx={index + 1} setObserverRef={setRef} />
                    ))}
                </section>
            </div>
        </>
    );
};
export default Approach;
